import { useLocation } from "react-router-dom";
import PageTemplate from "../components/common/PageTemplate";
import AddNewAddress from "../screen/locationAddress/AddNewAddress";

const AddNewAddressPage = () => {
  const location = useLocation();
  const isNew = location.pathname.includes("/new");

  return (
    <PageTemplate
      mainComponent={<AddNewAddress />}
      noPadding={true}
      logo={isNew ? "Tambah Alamat Baru" : "Edit Alamat"}
      back={"/location-address/my-address"}
    />
  );
};

export default AddNewAddressPage;
